module.exports = __webpack_public_path__ + "img/barcelo-restaurant.7f7d1a02.jpg";